import React from 'react';
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible"

const Collapsible = CollapsiblePrimitive.Root

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger

const CollapsibleContent: React.FC<CollapsiblePrimitive.CollapsibleContentProps> = ({ children, ...props }) => (
  <CollapsiblePrimitive.CollapsibleContent {...props}>
    <style>
      {`
        .CollapsibleContent[data-state="open"] {
          animation: slideDown 200ms ease-in-out;
        }
        .CollapsibleContent[data-state="closed"] {
          animation: slideUp 200ms ease-in-out;
        }

        @keyframes slideDown {
          from {
            height: 0;
          }
          to {
            height: var(--radix-collapsible-content-height);
          }
        }

        @keyframes slideUp {
          from {
            height: var(--radix-collapsible-content-height);
          }
          to {
            height: 0;
          }
        }
      `}
    </style>
    {children}
  </CollapsiblePrimitive.CollapsibleContent>
);

export { Collapsible, CollapsibleTrigger, CollapsibleContent }
